import {useState} from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function useEmail(initial: string = "") {
  const [email, setEmail] = useState<string>(initial)
  const isValid = EMAIL_REGEX.test(email.trim())
  return { email, setEmail, isValid }
}
